import { Injectable } from '@angular/core';
import * as wjcCore from '@grapecity/wijmo';
import { PAGE_SIZE_ARRAY } from '../../../environments/environment';
declare var $;

@Injectable()
export class WijmoService {

  constructor() { }
  /** wjInput初期化
  * テンプレートから取得したwjMenuを各component内のpropertyに格納し、初期設定 */
  public initWjInput(prop: any, wjInput: any): any {
    prop = wjInput;
    // templete側でvalidationをrequiredとした場合、0を初期値とする。
    if (prop.isRequired === true) {
      prop.value = 0;
    } else {
      prop.value = null;
    }
    return prop;
  }
  /** wjMenu(ページサイズ)のリスト初期化 */
  public initWjPageSizeList(wjMenu: any, defaultPageSize: number): any {
    const initWjMenu = wjMenu;
    const initWjMenu2 = wjMenu;
    const list = PAGE_SIZE_ARRAY;
    const listIcollect = new wjcCore.CollectionView(list);
    initWjMenu.itemsSource = listIcollect;
    initWjMenu.selectedValue = defaultPageSize;  // ページサイズの初期値指定
    initWjMenu.header = initWjMenu2.selectedItem.label;  // 画面描写
    return initWjMenu;
  }
  /** wjMenu再描写 */
  public renderWjMenu(wjMenu: any): any {
    const altWjMenu = wjMenu;
    const altWjMenu2 = wjMenu;
    altWjMenu.header = altWjMenu2.selectedItem.label;
    return altWjMenu;
  }
  /** 任意のフォームのWijmoに関連するinvalidClassを消す */
  public removeWjInvalidClass(id: string): void {
    $('#' + id).removeClass(
      'wj-unique-invalid wj-require-invalid wj-tel-invalid wj-fax-invalid wj-postcode-invalid wj-date-duplicate-invalid'
    );
  }
  /** 全てのフォームのWijmoに関連するinvalidClassを消す */
  public resetWjInvalidClasses(idNames: string[]): void {
    idNames.forEach(id => {
      $('#' + id).removeClass(
        'wj-unique-invalid wj-require-invalid wj-tel-invalid wj-fax-invalid wj-postcode-invalid wj-date-duplicate-invalid'
      );
    });
  }
  /** wjDateのFrom(開始日)がTo(終了日)より後の時、To = Fromにする。
   * @return {Date} Toの判定・変換結果
  */
  public wjDateEndSync(wjDateStart: Date, wjDateEnd: Date): Date {
    if (wjDateStart > wjDateEnd) {
      wjDateEnd = wjDateStart;
    }
    return wjDateEnd;
  }

  /** WjInputMaskで自動生成されるアンダーバーを削除します */
  cleanWjMaskString(str: string): string {
    return str.replace(/_/g, '');
  }

  /** WjInputMaskで自動生成されるアンダーバー、ハイフンを削除します
   * ただし「___-____」だった場合空白文字を返します
   */
  cleanWjMaskPostcodeString(str: string): string {
    if (str === '___-____') {
      return str.replace(/_/g, '').replace(/-/g, '');
    } else {
      return str.replace(/_/g, '');
    }
  }

  /** PDF出力前の高さ調整用にwijmoグリッドの行数を取得
   * @param str 対象文字列
   */
  getRowsByWjGrid(str: string): number {
    if (!str) {
      return;
    }

    let numOfRows = 1;
    let count = 0;
    for (let i = 0; i < str.length; i++) {
      count += this.getCharWidthNumber(str[i]);
      // 改行コードがあった場合
      if (str[i] === '\n') {
        count = 0;
        numOfRows++;
        continue;
      }
    }
    return numOfRows;
  }

  insertNewLineCode(str: string, insertIndex: number): string {
    if (!str) {
      return;
    }

    let count = 0;
    for (let i = 0; i < str.length; i++) {
      count += this.getCharWidthNumber(str[i]);
      // {insertCount}番目の文字に改行コード挿入
      if (count >= insertIndex) {
        str = str.slice(0, i) + '\n' + str.slice(i);
        count = 0;
        continue;
      }
      // 改行コードがあった場合
      if (str[i] === '\n') {
        count = 0;
        continue;
      }
    }
    return str;
  }

  /** 引数が全角か半角かを判定。全角なら1, 半角なら0.5を返す */
  getCharWidthNumber(input: string): number {
    // 半角英数字（大文字・小文字）
    if (input.match(/^[0-9a-zA-Z!#$%&()*+,.:;=?@\[\]^_{}<>-]+$/)) {
      return 0.5;
    }
    // 半角カナ
    if (input.match(/^[ｧ-ﾝﾞﾟ\-]*$/)) {
      return 0.5;
    }
    // 全角文字（ひらがな・カタカナ・漢字 etc.）
    if (input.match(/^[^\x01-\x7E\xA1-\xDF]+$/)) {
      return 1;
    }
    // その他の識別できなかった文字に関しては文字途切れバグ回避の為、暫定で1を返す
    return 1;
  }

  /** PDF出力前の高さ調整用にwijmoグリッドの行数を取得
   * @param str 対象文字列
   */
  getRowsByWjGridNumOfString(str: string, returnIndex: number): number {
    if (!str) {
      return;
    }

    let numOfRows = 1;
    let count = 0;
    for (let i = 0; i < str.length; i++) {
      count += this.getCharWidthNumber(str[i]);
      // 改行コードがあった場合
      if (count >= returnIndex) {
        count = 0;
        numOfRows++;
        continue;
      }
    }
    return numOfRows;
  }

  openWjInputDateCalender(tmpWjInputDate: any) {
    // if (this.asyncRequesting) {
    //   return;
    // }
    if (tmpWjInputDate) {
      tmpWjInputDate.isDroppedDown = true;
    }
  }
}
